export default "__VITE_ASSET__68f41a2f__"